"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _BrowserReadiness = require("./BrowserReadiness");
Object.keys(_BrowserReadiness).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BrowserReadiness[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _BrowserReadiness[key];
    }
  });
});